exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pc .checkout-leaving .btn {\n  width: 100%;\n  margin-top: 15px;\n}\n\n", ""]);

// exports
